var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({attrs:{"icon":"","x-large":""}},_vm.inputListeners),[_c('v-icon',[_vm._v(" mdi-close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }